import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { getToken, getMenuFlag } from "@/utils/auth";
import layout from "@/views/layout/index.vue";
import { getCurrUserResources } from "@/api/login";
import store from "@/store";
import { Route } from "vue-router";
import { UserModule } from "@/store/modules/user";

import { PermissionModule } from '../store/modules/permission'

import { filterAsyncRoutes } from "@/utils/systerm";
import { testData } from "@/api/testData";

import { keyNameTranslate, copyMemberByKey } from '../utils/common' // keyNameTranslate 批量更改对象键名
import { handleMemberByKey1 } from '../utils/data2menuTree'

Vue.use(VueRouter);

export const constantRoutes: RouteConfig[] = [
  {
    path: "/",
    name: "login",
    redirect: '/teacher'
  },
  {
    path: "/teacher",
    name: "teacher",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/school",
    name: "school",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/registered",
    name: "registered",
    component: () => import("@/views/login/module/registered.vue")
  },
  {
    path: "/layout",
    name: "layout",
    component: layout,
    children: []
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: constantRoutes
});

// 路由白名单
const whitelist = ['/', '/school', '/teacher', '/registered'];

// 用户登录成功只从后端获取一次菜单数据
let loadRouter = true;

//进入路由前的判断
router.beforeEach(async (to, from, next) => {
  if (UserModule.token || getToken()) {
    if (to.path === "/" || to.path === "/school" || to.path === "/teacher") {
      next({ path: "layout" });
    } else {
      let flag = Boolean((sessionStorage.loadMenu == "yes") || (getMenuFlag() == "yes"))
      if (flag && loadRouter) {
        loadRouter = false;
        await PermissionModule.GetMenus() // vuex 中获取后台返回的菜单树
        // await PermissionModule.loadPermissions() // 获取后台权限参数 del 已在GetMenus调用 this.loadPermissions()!!!
        UserModule.updateLoadMenu();   // UserModule.loadMenu 将这个变量置为 false
        loadMenu(next, to);    // 处理后台数据为 路由表，加载动态路由表
      } else {
        next()
      }
    }
  } else {
    // 用户未登录则将获取路由参数初始化
    loadRouter = true;
    if (whitelist.includes(to.path)) {
      next();
    } else {
      next({ path: "/" })
    }
  }
});

export const loadMenu = async (next: any, to: any) => {
  let opitons = [
    { href: 'path', config: 'replace' },
    { childList: 'children', config: 'replace' },
    { component: 'layout', config: 'add' },
    { component: 'component', config: 'replace', handle: (e, curPath) => { if (curPath && curPath !== e.path) { return (curPath + e.path).slice(1) } } },
    { path: 'path', config: 'replace', mode: 'mixed', handle: (e, curPath) => { if (curPath && curPath !== e.path) { return e.path && e.path.slice(1) } } }
  ]
  let reNameMenuTree = await handleMemberByKey1(PermissionModule.menuTreeList, opitons)

  let asyncRouter = filterAsyncRoutes(reNameMenuTree.data);
  store.dispatch("GenerateRoutes", asyncRouter).then(() => {
    // 存储路由
    router.addRoutes(asyncRouter); // 动态添加可访问路由表
    next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
  });
};

export default router;
